/**
 * @name: MobileChannelTitle
 * @author: Seeker
 * @date: 2022-03-19 11:02
 * @description：MobileChannelTitle
 * @update: 2022-03-19 11:02
 */

import React, {Component} from 'react';
import MobileViewAdapt3 from "./MobileViewAdapt3";

export default class MobileChannelTitle extends Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps);
     }

    render() {
        const titleContainerStyle = MobileViewAdapt3.getChannelCardTitleContainerStyle(
            this.props.clientWidth,
            this.props.nameAndBedLarger,
            this.props.grid[0]);
        const title = MobileViewAdapt3.getChannelCardTitle(
            this.props.contentObj,
            this.props.darkModule,
            this.props.item,
            this.props.abnInfo,
            this.props.abnInfoBackColor,
            this.props.flicker,
            this.props.grid[1],
            this.props.clientWidth,
            this.props.nameAndBedLarger,
            this.props.onNameClick,
            this.props.nameTextFontSize,
            this.props.departmentShow,
            this.props.bedShowLeft,
            this.props.bedTextFontSize,
            this.props.batteryShowRule,
            this.props.clearEmergencyAlarmEvent,
            this.props.avgBeat,
            this.props.hrRanger);
        return <div id={'card_title_container'} style={titleContainerStyle}>
            {title}
        </div>
    }
}
